<template>
  <div>
    <el-table
      :data="userList"
      height="calc(100vh - 353px)"
      :row-class-name="tableRowClassName"
    >
      <!-- <el-table-column label="仓位ID" fixed="left" min-width="180">
        <template slot-scope="scope">{{ scope.row.positionId }}</template>
      </el-table-column> -->

      <!-- <el-table-column prop="userType" label="用户身份">
        <template slot-scope="scope">
          <span v-if="scope.row.userType == '普通用户'" class="red">{{
            scope.row.userType
          }}</span>
          <span v-else class="cc">{{ scope.row.userType }}</span>
        </template>
      </el-table-column> -->
      <el-table-column
        prop="userId"
        label="用户UID"
        align="center"
        fixed="left"
        min-width="150"
      >
        <template slot-scope="scope">
          <span
            @click="showBox(scope.row, 2)"
            :class="{
              tdRed: scope.row.mark == true,
              blue: scope.row.mark != true,
              myTd: true,
            }"
            >{{ scope.row.userId }}</span
          >
        </template>
      </el-table-column>

      <el-table-column
        prop="channelUserId"
        label="合伙人UID"
        align="center"
        min-width="150"
      >
        <template slot-scope="scope">
          <span @click="showBox(scope.row, 1)" class="myTd blue">{{
            scope.row.channelUserId
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="userTypeDesc"
        label="用户类型"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          {{ scope.row.userTypeDesc || '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="type" label="类型" align="center" min-width="150">
        <template slot-scope="scope">
          {{ scope.row.type }}
        </template>
      </el-table-column>
      <el-table-column prop="coin" label="币种" align="center" min-width="140">
        <template slot-scope="scope">
          {{ scope.row.coin }}
        </template>
      </el-table-column>
      <el-table-column
        prop="availableChange"
        label="可用变动"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">
          <!-- <el-tag type="success" v-if="scope.row.availableChange==1">增加</el-tag>
          <el-tag v-else>减少</el-tag> -->
          {{ scope.row.availableChange }}
        </template>
      </el-table-column>

      <el-table-column
        prop="availableChangeBefore"
        label="交易前可用金额"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">
          {{ scope.row.availableChangeBefore }}
        </template>
      </el-table-column>
      <el-table-column
        prop="availableAfter"
        label="交易后可用金额"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">
          {{ scope.row.availableAfter }}
        </template>
      </el-table-column>
      <el-table-column
        prop="frozeChange"
        label="冻结变动"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">
          {{ scope.row.frozeChange }}
        </template>
      </el-table-column>
      <el-table-column
        prop="frozeChangeBefore"
        label="冻结前可交易金额"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">
          {{ scope.row.frozeChangeBefore }}
        </template>
      </el-table-column>
      <el-table-column
        prop="frozeAfter"
        label="冻结后可交易金额"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">
          {{ scope.row.frozeAfter }}
        </template>
      </el-table-column>
      <el-table-column label="创建时间" width="150">
        <template slot-scope="scope">{{
          scope.row.createdTime | moment
        }}</template>
      </el-table-column>
      <!-- <el-table-column label="备注" align="right" min-width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.remark }}</span>
        </template>
      </el-table-column> -->
      <!-- <el-table-column  label="是否展示备注">
        <template slot-scope="scope">
          <span v-if="scope.row">{{ scope.row.type}}</span>
        </template>
      </el-table-column> -->

      <!-- <el-button type="text" size="mini" @click="goDetail(scope.row)">资产明细</el-button> -->
      <!-- <el-table-column label="操作" align="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            @click="handleUpdate(scope.row)"
            v-if="scope.row.type === 0"
            >修改备注</el-button
          >
        </template>
      </el-table-column> -->
    </el-table>
    <div class="pag">
      <pagination
        :size="pagination.size"
        :total="totalCount"
        :page="pagination.page"
        @pageChanged="pageChanged"
      ></pagination>
    </div>
    <!-- <update-dialog
      :val="userinfoDetail"
      :updateForm="updateForm"
    ></update-dialog> -->

    <!-- 编辑用户信息dialog -->
    <el-dialog :visible.sync="centerDialogVisible" width="30%" center>
      <div slot="title" class="dialog_title">
        <span>修改备注</span>
        <img :src="cha" alt="" @click="centerDialogVisible = false" />
      </div>
      <div class="main">
        <div class="title">备注信息</div>
        <div class="content">
          <el-input
            type="textarea"
            :rows="5"
            placeholder="请输入备注信息"
            maxlength="50"
            show-word-limit
            v-model="textarea2"
          >
          </el-input>
        </div>
        <div class="btn">
          <el-button size="mini" type="primary" @click="add">添 加</el-button>
        </div>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
    <el-button @click="centerDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
  </span> -->
    </el-dialog>
    <UserDetailDialog :id="id" :type="type" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from "vuex";
import Pagination from "components/pagination";
import updateDialog from "../updatedialog";
import cha from "@/assets/partnerCenter/cha.png";
import UserDetailDialog from "components/userDetailDialog";

export default {
  name: "UserList",
  data() {
    return {
      cha,
      updateForm: {},
      updateUserTypeDialogVisible: false,
      newUserType: "",
      selectedForUserType: {},
      centerDialogVisible: false,
      textarea2: "",
      type: "",
      id: "",
    };
  },
  components: {
    Pagination,
    UserDetailDialog,
    updateDialog,
  },
  methods: {
    ...mapActions("spotBill", ["addRemark"]),
    ...mapMutations("spotBill", [
      "setUserinfoDetailDialogVisible",
      "setUserinfoDetail",
    ]),
    ...mapMutations("contractassets", ["setUserDetailInfoVisible"]),

    pageChanged(pagination) {
      this.$emit("refresh", pagination);
    },
    handleUpdate(row) {
      this.updateForm = row;
      // this.setUserinfoDetail(row);
      // this.setUserinfoDetailDialogVisible(true);
      this.centerDialogVisible = true;
      this.textarea2 = row.remark;
    },
    add() {
      this.addRemark({
        channelId: this.userInfo.channelId,
        userId: this.updateForm.id,
        remark: this.textarea2,
      }).then((res) => {
        if (res.code == 0) {
          this.$message.success("添加成功");
          (this.textarea2 = ""), (this.centerDialogVisible = false);
          this.$emit("refresh");
        }
      });
    },
    goDetail(row) {
      this.$router.push({ path: `/home/spotBill/detail`, query: row });
    },
    showBox(row, type) {
      this.type = type;
      this.id = type == 2 ? row.userId : row.channelUserId;
      this.setUserDetailInfoVisible(true);
    },
    tableRowClassName({ row }) {
      if (row.mark == true) {
        return "redRow";
      }
      return "";
    },
  },
  computed: {
    // ...mapGetters('user', ['userList']),
    ...mapState(["userInfo"]),
    ...mapState("spotBill", [
      "pagination",
      "userList",
      "totalCount",
      "userinfoDetail",
      "userinfoDetailDialogVisible",
    ]),
  },
};
</script>

<style lang="less" src="../../../../../styles/table.less" scoped>
// .pag{
//   display: flex;
//   justify-content: center;
// }
// .user-type-select {
//   width: 100%;
// }
// .red {
//   color: skyblue;
//   font-weight: bold;
// }
// .cc {
//   color: #97a0ff;
//   font-weight: bold;
// }
// ::v-deep .el-dialog__title {
//   color: #6767b3;
//   font-size: 24px;
// }
// ::v-deep.el-dialog__headerbtn {
//   font-size: 26px;
// }
// ::v-deep .el-dialog__body {
//   display: flex;
//   justify-content: center;
//   .main {
//     width: 100%;
//     position: relative;
//     .box-card {
//       width: 100%;
//       height: 260px;
//       .el-card__body {
//         height: 86%;
//         display: flex;
//         flex-direction: column;
//         justify-content: space-between;
//         .el-textarea{
//           box-shadow: 0px 0px 1px rgba(24, 26, 32, 0.1), 0px 3px 6px rgba(71, 77, 87, 0.04), 0px 1px 2px rgba(24, 26, 32, 0.04);
//         }
//         .el-textarea__inner{
//           padding: 18px 16px;
//         }
//         .btn{
//           display: flex;
//           justify-content: center;
//            .el-button--primary{
//       width: 156px;
//       height: 37px;
//       background: #707AFF;
//       border-radius: 4px;
//     }
//         }
//       }
//     }
//   }
// }
// ::v-deep .el-dialog--center {
//   margin-top: 5vh;
//   width: 468px;
//   // height: 557px;
//   background: #f5f6ff;
//   border-radius: 8px;
// }
::v-deep.el-table th {
  font-weight: bold;
  color: #909399;
}
</style>
